module.exports = __webpack_public_path__ + "static/media/diamond-card.6f18a74f.png";